import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    paper: {
        padding: theme.spacing(2)
    },
    rootFab: {
        alignSelf: 'flex-end',
        textAlign: 'end',
        [theme.breakpoints.down('sm')]: {
            alignSelf: 'center',
        }
    },
}))